import { connect } from "react-redux";
import ErrorsContainer from "./ErrorsContainer";

export default connect((state: any) => ({
  integrationErrors: state.errors.integrationErrors
}))(ErrorsContainer);
